// src/api/common_api.js

// 🔁 ONLY THIS VALUE YOU WILL CHANGE
const SERVER_URL = "https://suryojasvi-reflection-api.wyzmindz.com";

// 🔹 API BASES
export const API_BASE = `${SERVER_URL}/api`;
export const AUTH_API = `${SERVER_URL}/api/auth`;
